import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
type InfoTypes = "success" | "error";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

export interface S {
  // Customizable Area Start
  isLoading: boolean;
  isInfoDialogOpen: boolean;
  infoType: InfoTypes;
  infoMessage: string;
  // Customizable Area End
}

export interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class EmailVerificationController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  verifyEmailApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.CountryCodeMessage),
    ];
    this.receive = this.receive.bind(this);

    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    this.state = {
      // Customizable Area Start
      isLoading: false,
      isInfoDialogOpen: false,
      infoType: "success",
      infoMessage: "",
      // Customizable Area End
    };

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.verifyEmailApiCallId) {
        if (responseJson.message) {
          this.openInfoDialog("success", configJSON.accountVerifiedText);
        } else {
          this.openInfoDialog("error");
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount(): Promise<void> {
    this.handleEmailVerification();
  }

  handleEmailVerification = () => {
    const params = new URLSearchParams(window.location.search);
    const verificationToken = params.get(configJSON.EMAIL_VERIFICATION_TOKEN);

    if (!verificationToken) {
      this.openInfoDialog("error");
      return;
    }
    this.setState({ isLoading: true });
    const query = `${configJSON.EMAIL_VERIFICATION_TOKEN}=${verificationToken}`
    this.verifyEmailApi(verificationToken);
  };

  openInfoDialog = (infoType: InfoTypes, infoMessage: string = "") => {
    this.setState({
      isInfoDialogOpen: true,
      infoType,
      infoMessage,
      isLoading: false,
    });
  };

  closeInfoDialog = () => {
    const { infoType } = this.state;
    const routePath =
      infoType === "success"
        ? "EmailAccountLoginBlock"
        : "EmailAccountRegistration";
    this.handleRedirection(routePath);
  };

  handleRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  verifyEmailApi = (token: string) => {
    const apiEndpoint = `${configJSON.emailVerificationApiEndPoint}?token=${token}`

    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.verifyEmailApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };
  // Customizable Area End
}
